<template>
  <div :class="'drainage ' + (preventPop ? 'prevent-pop' : '') " ref="pageContent" @touchstart="handleTouchStart" @touchend="handleTouchEnd">
    <div v-wechat-title="'《骑士冲呀》 一路陪伴，感谢相遇'"></div>
    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' v-on:channelCallback='selectCallback' :gameName="gameName"
      :downloadUrl="downloadUrl" :loginTypes="loginTypes" channelTips="角色UID可在游戏中—设置—UID查看" :autoOpenOS="autoOpenOS"
      @loginSuccess="loginSuccess" noAuthLogin></Login>
    <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback='osCancell'
    @getSelectInfo='getSelectInfo' :gameName="gameName" :isBlur="preventPop"></Os>
    <!-- 头部 -->
    <Header v-if='true' :config='headerConfig' :isBlur="preventPop" :isShowInfo='true' :isOnline='1' @reInit="reInit" />

    <!-- 首页 -->
    <div class="drainage-box page" :class="{ 'blur-wrap': preventPop,'show-footer': activePage === 1}" ref="scrollablePage" @scroll="handleScroll">
      <div class="active-page">
        <div class="banner"></div>
        <div class="content-01"></div>
        <div class="content-02">
          <div class="title"></div>
          <div class="meet-rewards-box">
            <div class="explain-btn" @click="showPopup('meetRulePop')"></div>
          </div>
          <div :class="'receive-meet-btn ' + (isMeetReward ? 'received' : '')" @click="receiveMeetReward()"></div>
        </div>
        <div class="content-03">
          <div class="title"></div>
          <div class="repay-rewards-box">
            <div
              v-for="reward in rewardList"
              :key="reward.id"
              :class="['reward', `reward-0${reward.id}` ,  { 'on': reward.id <= repayLevel }]"
            ></div>
          </div>
          <div class="clone-reward-box">
            <div
              v-for="reward in rewardList"
              :key="reward.id"
              class="clone-reward"
              @click="showRewardPopup(reward)"
            ></div>
          </div>
          <div class="explain-btn" @click="showPopup('repayRulePop')"></div>
          <div :class="'receive-repay-btn ' + (isRepayReward ? 'received' : '')" @click="receiveRepayReward()"></div>
          <div class="tip"></div>
        </div>
        <div class="content-04">
          <div class="download-btn" @click="downLoad()"></div>
        </div>
      </div>
    </div>
    <div class="foot-page page" :class="{ 'active': activePage === 1 }">
      <Footer :gameName="gameName" />
    </div>

    <!--  微信遮罩弹窗 -->
    <div class="wx-download-pop popup_wrap" v-show="wxMaskPop">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="wx-box popup_wrap-box">
        </div>
      </transition>
      <div class="close-bg" v-show="wxMaskPop" @click="closePopup('wxMaskPop')"></div>
    </div>

    <!--  规则说明(相遇)弹窗 -->
    <div class="meet-rule-pop popup_wrap" v-show="meetRulePop">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="rule-box popup_wrap-box">
        </div>
      </transition>
      <div class="close-bg" v-show="meetRulePop" @click="closePopup('meetRulePop')"></div>
    </div>

    <!--  规则说明(回馈)弹窗 -->
    <div class="repay-rule-pop popup_wrap" v-show="repayRulePop">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="rule-box popup_wrap-box">
        </div>
      </transition>
      <div class="close-bg" v-show="repayRulePop" @click="closePopup('repayRulePop')"></div>
    </div>

    <!--  充值额度(1)弹窗 -->
    <div class="repay-award-01-pop popup_wrap" v-show="repayAwardPop01">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="award-box popup_wrap-box">
        </div>
      </transition>
      <div class="close-bg" v-show="repayAwardPop01" @click="closePopup('repayAwardPop01')"></div>
    </div>

     <!--  充值额度(30)弹窗 -->
     <div class="repay-award-02-pop popup_wrap" v-show="repayAwardPop02">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="award-box popup_wrap-box">
        </div>
      </transition>
      <div class="close-bg" v-show="repayAwardPop02" @click="closePopup('repayAwardPop02')"></div>
    </div>

     <!--  充值额度(200)弹窗 -->
     <div class="repay-award-03-pop popup_wrap" v-show="repayAwardPop03">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="award-box popup_wrap-box">
        </div>
      </transition>
      <div class="close-bg" v-show="repayAwardPop03" @click="closePopup('repayAwardPop03')"></div>
    </div>

     <!--  充值额度(500)弹窗 -->
     <div class="repay-award-04-pop popup_wrap" v-show="repayAwardPop04">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="award-box popup_wrap-box">
        </div>
      </transition>
      <div class="close-bg" v-show="repayAwardPop04" @click="closePopup('repayAwardPop04')"></div>
    </div>

    <!--  确认角色弹窗 -->
    <div class="confirm-role-pop popup_wrap" v-show="confirmRolePop">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="role-box popup_wrap-box">
          <p class="role-info-box">
            <span class="role-name">{{ userInfo.role_name || role_name }}</span>
            <span class="server-name">[{{ userInfo.server_name || server_name }}]</span>
          </p>
          <div class="btn-box">
            <div class="change-role-btn btn" @click="bindRole()"></div>&nbsp;
            <div class="confirm-btn btn" @click="confirmReward()"></div>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-show="confirmRolePop" @click="closePopup('confirmRolePop')"></div>
    </div>

    <!-- 无角色弹窗 -->
    <div class="none-role-pop popup_wrap" v-show="noneRolePop">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="role-box popup_wrap-box">
          <div class="download-btn" @click="downLoad('noneRolePop')"></div>
        </div>
      </transition>
      <div class="close-bg" v-show="noneRolePop" @click="closePopup('noneRolePop')"></div>
    </div>
  </div>
</template>

<script>
import { Toast , Indicator} from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
// import Header from '@/components/Header'
import Header from '../Header/index.vue';
import Footer from '@/components/Footer'
import { headerConfig } from '../headerConfig';
import { onGetInitDataAPI , receiveMeetRewardAPI, receiveRepayRewardAPI,GetRoleList  } from '../api'
import { getRandomString, buriedLogger , wechatBrowser } from '@/utils/utils'
import { APP_ID, PAGE_ID } from "@/config/constant";

export default {
  name: 'drainage',
  components: {
    Header,
    Footer,
    Login,
    Os
  },
  data () {
    return {
      headerConfig,
      gameName: 'mzzg',
      account: null,
      user_id: null,
      role_name: '',
      server_name: '',
      downloadUrl: 'https://mtzg.qingcijoy.com/',
      loginTypes: ["sms", "password"],
      selectInfo: {},
      autoOpenOS: false, //是否需要区组选角
      isMeetReward: false, // 是否领取相遇奖励
      isRepayReward: false, // 是否领取回馈奖励
      reachedRewards: [], // 已达到奖励
      repayLevel: 0, // 回馈等级
      secondConfirm: false, //二次确认弹窗
      awardType: "", // 奖励类型
      hasRole: false, // 是否有角色
      // 弹窗
      meetRulePop: false, // 规则说明(相遇)弹窗
      repayRulePop: false, // 规则说明(回馈)弹窗
      repayAwardPop01: false, // 充值额度(1)弹窗
      repayAwardPop02: false, // 充值额度(30)弹窗
      repayAwardPop03: false, // 充值额度(200)弹窗
      repayAwardPop04: false, // 充值额度(500)弹窗
      confirmRolePop: false, // 确认角色弹窗
      noneRolePop: false, // 无角色弹窗
      wxMaskPop: false, // 微信遮罩
      preventPop: true, // 未登录时遮罩
      // 是否显示页脚
      startY: 0, // 开始Y坐标
      endY: 0, // 结束Y坐标
      activePage: 0, // 当前页数
      isAtBottom: false,  // 是否到底部
      // 奖励列表
      rewardList : [
        {id: 1, status: 0},
        {id: 2, status: 0},
        {id: 3, status: 0},
        {id: 4, status: 0}
      ]
    }
  },
  created () {
    // 初始化
    this.getLoginContainer();
    this.reachedRewards = this.rewardList.filter(item => item.status === 1);
    // 判断达到的档次
    this.reachedRewards.forEach(item => {
      this.repayLevel = item.id;
    });

    // 埋点
    const bl = buriedLogger('mzzg', '骑士冲呀_导量至迷途')
    this.logger = bl;
    setTimeout(() => {
      this.logger.sum('骑士冲呀_导量至迷途访问')
    }, 200)
  },
  mounted () {
    this.$nextTick(() => {
      this.isSetShare();
    })
  },
  computed: {
    ...mapState(['userInfo', 'activeInfo', 'isShowLogin', 'isShowOs']),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (oldValue.account) {
          if (newValue.account !== oldValue.account) {
            if (!newValue.account) {
              // TAG: 注销的时候
              this.reInit()
            } else {
              // console.log('登录成功');
              this.getLoginContainer()
            }
          }
        }
      }
    },
  },
  methods: {
    // 是否至底
    handleScroll() {
      const scrollablePage = this.$refs.scrollablePage;
      const scrollTop = scrollablePage.scrollTop;
      const scrollHeight = scrollablePage.scrollHeight;
      const clientHeight = scrollablePage.clientHeight;

      // 检测是否滚动到底部
      this.isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
    },
    handleTouchStart(event) {
      this.startY = event.touches[0].clientY;
    },
    handleTouchEnd(event) {
      this.endY = event.changedTouches[0].clientY;
      const deltaY = this.startY - this.endY;

      if (this.activePage === 0 && this.isAtBottom && deltaY > 50) {
        // 向上滑动，显示页脚
        this.activePage = 1;
      } else if (this.activePage === 1 && deltaY < -10) {
        // 向下滑动，返回第一页
        this.activePage = 0;
      }
    },

    // 选择角色后
    selectCallback() {
      // console.log('~~~~~~~~~绑定角色成功~~~~~~~~~~~~');
      if (!this.secondConfirm){
        this.showPopup('confirmRolePop');
      }
    },
    getSelectInfo(selectInfo) {
      this.selectInfo = selectInfo
      selectInfo.account = this.userInfo.account
      this.setUserInfo(selectInfo);
    },
    loginSuccess() {
      // console.log("~~~~~~~~~登录成功~~~~~~~~~~~~~~~~");
      this.getLoginContainer();
    },
    // 初始化
    getLoginContainer() {
      Indicator.open();
      onGetInitDataAPI()
        .then((response) => {
          if (Number(response.code) == 200) {
            this.preventPop = false;
            this.activity = response.data.activity;
            this.user_info = response.data.user_info;
            this.user_id = response.data.user_info.user_id;
            this.role_name = response.data.user_info.role_name;
            this.server_name = response.data.user_info.server_name;

            this.isMeetReward = response.data.activity.is_ordinary_reward; // 是否领取相遇奖励
            this.isRepayReward = response.data.activity.is_reward; // 是否领取回馈奖励
            // this.secondConfirm = this.isMeetReward || this.isRepayReward; //二次确认弹窗
            this.rewardList = response.data.activity.reward_list; // 回馈等级
            this.reachedRewards = this.rewardList.filter(item => item.status === 1);
            // 判断达到的档次
            this.reachedRewards.forEach(item => {
              this.repayLevel = item.id;
            });

            this.onInitDataCallback(response);
            this.setUserInfo(response.data.user_info);
            this.setActiveInfo(response.data.activity);
            return;
          }
          // 登录异常
          if (Number(response.code) == 401 && response.data.info) {
            this.preventPop = true;
            this.onInitDataCallback(response);
            this.onToast('信息加载失败，请先登入游戏');
            return;
          }
          // 请登录
          if (Number(response.code) == 401) {
            this.onInitDataCallback(response);
            return;
          }
          // 无账号
          if (Number(response.code) == 402) {
            this.onToast('登录失败，该账号下未发现《骑士冲呀》角色' , 3000);
            this.changeLoginPopup(true);
            return;
          }
        })
        .finally(() => {
          Indicator.close();
        });
    },
    // 领取相遇奖励
    receiveMeetReward() {
      this.awardType = "meet";
      this.logger.sum('骑士冲呀_导量至迷途_一键领取相遇礼');

      // 有无登录
      if (this.userInfo.account === undefined || this.userInfo.account === '') {
        this.autoOpenOS = true;
        this.changeLoginPopup(true);
        return
      }

      if (this.isMeetReward) {
        this.onToast("您已领取过相遇礼，请勿重复领取~", 2000);
        return;
      }

      // 有无绑定角色
      if(this.userInfo.role_id === undefined || this.userInfo.role_id === ''){
        this.bindRole();
      } else {
        !this.secondConfirm ? this.showPopup('confirmRolePop') : this.confirmReward();
      }
    },
    // 领取回馈奖励
    receiveRepayReward() {
      this.awardType = "repay";
      this.logger.sum('骑士冲呀_导量至迷途_一键领取回馈礼');

      // 有无登录
      if (this.userInfo.account === undefined || this.userInfo.account === '') {
        this.autoOpenOS = true;
        this.changeLoginPopup(true);
        return
      }

      if(this.repayLevel === 0){
        this.onToast("领取失败 您未达到当前板块的回馈标准~", 2000);
        return;
      }

      if (this.isRepayReward) {
        this.onToast("您已领取过回馈礼，请勿重复领取~", 2000);
        return;
      }

      // 有无绑定角色
      if(this.userInfo.role_id === undefined || this.userInfo.role_id === ''){
        this.bindRole();
      }else{
        !this.secondConfirm ? this.showPopup('confirmRolePop') : this.confirmReward();
      }
    },

    // 确认领取弹窗
    confirmReward(){
      const receiveParams = {
        user_id: this.user_id,
        role_id: this.userInfo.role_id,
        server_id: this.userInfo.server_id,
        role_name: this.userInfo.role_name,
        server_name: this.userInfo.server_name
      }
      // console.log("this.awardType:",this.awardType);
      if (this.awardType === "meet") {
        this.logger.sum('骑士冲呀_导量至迷途_确认领取相遇礼');
        // 相遇
        // console.log("相遇礼",receiveParams);
        receiveMeetRewardAPI(receiveParams).then((response) => {
          if (response.code == 200) {
            this.onToast("领取成功", 2000);
            this.isMeetReward = true;
            // this.secondConfirm = true;
            this.closePopup('confirmRolePop');
          } else {
            this.onToast(response.message);
          }
        });
      }else if (this.awardType === "repay") {
        this.logger.sum('骑士冲呀_导量至迷途_确认领取回馈礼');
        // 回馈
        // console.log("回馈礼",receiveParams);
        receiveRepayRewardAPI(receiveParams).then((response) => {
          if (response.code == 200) {
            this.onToast("领取成功", 2000);
            this.isRepayReward = true;
            // this.secondConfirm = true;
            this.closePopup('confirmRolePop');
          } else {
            this.onToast(response.message);
          }
        });
      }
    },
    // 绑定角色
    bindRole() {
      this.confirmRolePop = false;
      this.noneRolePop = false;

      if(!this.hasRole){
        // console.log("没绑定角色~~~");
        const params = {
          account: this.userInfo.account,
          page_id: PAGE_ID[this.gameName],
          app_id: APP_ID[this.gameName]
        }

        // 查角
        GetRoleList(params).then((response) => {
          if (Number(response.code) === 200) {
            this.hasRole = true;
            this.changeOsPopup(true);
          }
        })
        .catch((response) => {
          if (Number(response.code) === 401) {
            this.showPopup('noneRolePop');
          }
        });
      }else {
        this.changeOsPopup(true);
      }

      this.logger.sum('骑士冲呀_导量至迷途_点击前往绑定角色');
    },
    reInit() {
    //  console.log('清除data里面相关数据');
     this.changeOsPopup(false);
     this.clearActiveInfo(); // 清除data里面相关数据
    },
    clearActiveInfo(){
      this.isMeetReward = false; // 领取相遇奖励按钮
      this.isRepayReward = false; // 领取回馈奖励按钮
      this.hasRole=false, // 是否有角色
      this.repayLevel = 0; // 回馈等级
      this.secondConfirm = false; //二次确认弹窗
      this.reachedRewards = []; // 已达到奖励
      this.preventPop = true;
      this.rewardList = [
        {id: 1, status: 0},
        {id: 2, status: 0},
        {id: 3, status: 0},
        {id: 4, status: 0}
      ]; // 奖励列表
      this.awardType = ""; // 奖励类型
      this.setInitUserInfo();
      this.setInitActiveInfo();
    },
    // 区组弹窗注销-相关参数复位
    osCancell() {
     this.changeOsPopup(false);
     this.preventPop = true;
    },
    downLoad(data){
      this.closePopup('noneRolePop');

      const actionType = data === 'noneRolePop' ? '无角色弹窗' : '直接下载';
      const isIOS = navigator.userAgent.match(/(iPhone|iPod|ios)/i);
      const deviceType = isIOS ? 'ios' : '安卓';

      this.downLoadLink = isIOS ?
       'https://apps.apple.com/cn/app/%E8%BF%B7%E9%80%94%E4%B9%8B%E5%85%89-%E8%B6%85%E7%88%BD%E8%82%89%E9%B8%BD%E5%83%8F%E7%B4%A0%E5%BC%B9%E5%B9%95%E5%B0%84%E5%87%BB/id6479300771'
       : 'https://download4.qcplay.com/apk-v2/qc-kol-1159146.apk';

      // 组合日志信息
      this.logger.sum(`骑士冲呀_导量至迷途_点击下载游戏(${actionType}-${deviceType})`);

      if (wechatBrowser()) {
        this.wxMaskPop = true;
      } else {
        location.href = this.downLoadLink;
      }

      if (wechatBrowser()) {
        this.wxMaskPop = true
      } else {
        location.href = this.downLoadLink
      }
    },
    showPopup (name) {
      // console.log('name', name);
      switch (name) {
        case 'meetRulePop':
          this.meetRulePop = true
          this.logger.sum('骑士冲呀_导量至迷途访问_打开规则说明(相遇)弹窗')
          break
        case 'repayRulePop':
          this.repayRulePop = true
          this.logger.sum('骑士冲呀_导量至迷途访问_打开规则说明(回馈)弹窗')
          break
        case 'repayAwardPop01':
          this.repayAwardPop01 = true
          this.logger.sum('骑士冲呀_导量至迷途访问_打开充值额度(1)弹窗')
          break
        case 'repayAwardPop02':
          this.repayAwardPop02 = true
          this.logger.sum('骑士冲呀_导量至迷途访问_打开充值额度(30)弹窗')
          break
        case 'repayAwardPop03':
          this.repayAwardPop03 = true
          this.logger.sum('骑士冲呀_导量至迷途访问_打开充值额度(200)弹窗')
          break
        case 'repayAwardPop04':
          this.repayAwardPop04 = true
          this.logger.sum('骑士冲呀_导量至迷途访问_打开充值额度(500)弹窗')
          break
        case 'confirmRolePop':
          this.confirmRolePop = true
          this.logger.sum('骑士冲呀_导量至迷途访问_打开确认角色弹窗')
          break
        case 'noneRolePop':
          this.noneRolePop = true
          this.logger.sum('骑士冲呀_导量至迷途访问_打开无角色弹窗')
          break
        case 'wxMaskPop':
        this.wxMaskPop = true
        this.logger.sum('骑士冲呀_导量至迷途访问_微信下载弹窗')
        break
      }
    },
    // 不同档位奖励弹窗
    showRewardPopup(reward){
      this.showPopup(`repayAwardPop0${reward.id}`);
    },
    closeSave() {
      this.saveShow = !this.saveShow
    },
    // TAG: 其他简易封装的方法
    onToast (config , duration) {
      const curConfig = {
        duration: duration || 1000,
        className: 'toasts'
      }
      if (!config) {
        console.error('缺少config参数')
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig)
    },
    closePopup(name) {
      this[name] = false;
    },
    // 前往重定向
    goLink (url, loggerName) {
      if (url === '') {
        this.onToast('敬请期待！')
        return
      }
      this.logger.sum(loggerName)
      setTimeout(() => { window.location.href = url }, 200)
    },
    // 微信分享
    isSetShare () {
      this.setShare({
        link: `https://h5.qingcigame.com/mitu/drainage/enter${getRandomString()}`,
        title: '《骑士冲呀》',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/jyDUA8z9hzNGSUXep8Oqv5yKno1o5YDEAldUTkiy.png',
        desc: '一路陪伴，感谢相遇'
      })
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/mitu/drainage/index/index.vue